import { signIn } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function useHomeHook() {
  const searchParams = useSearchParams();
  const tokenUsuario = searchParams.get('data');
  const callbackUrl = searchParams.get('callbackUrl');

  async function logarUsuarioToken() {
    await signIn('token', {
      redirect: true,
      accessToken: tokenUsuario,
      callbackUrl: callbackUrl ?? '/',
    });
  }

  useEffect(() => {
    if (!tokenUsuario) return;
    logarUsuarioToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenUsuario]);

  return;
}
